import { useTranslation } from "react-i18next";

/** Badge « Actuel » / « À venir » affiché à côté de la période ; rien pour les prix passés. */
export const EntryStatusBadge = ({ status }: { status: "past" | "current" | "future" }) => {
    const [t] = useTranslation();

    if (status === "current") {
        return (
            <span className="rounded-full bg-green-100 text-green-700 text-[10px] font-medium px-1.5 py-0.5">
                {t("PriceHistory.Current")}
            </span>
        );
    }

    if (status === "future") {
        return (
            <span className="rounded-full bg-blue-100 text-blue-700 text-[10px] font-medium px-1.5 py-0.5">
                {t("PriceHistory.Future")}
            </span>
        );
    }

    return null;
};
